import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import createDecorator from 'final-form-focus'
import arrayMutators from "final-form-arrays";

const focusOnErrors = createDecorator();

class PageWizard extends Component {
	static propTypes = {
		onSubmit: PropTypes.func.isRequired
	}

	static Page = ({ children }) => children;

	constructor(props) {
		super(props)
		this.state = {
			page: 0,
			previousPage: [],
			values: props.initialValues || {},
		}

		this.baseState = this.state
	}

	next = values => {
		const { children } = this.props;
		const { page } = this.state;
		let { previousPage } = this.state;

		this.setState({
			...this.state,
			previousPage: previousPage.concat(page),
			page: Math.min(page + 1, children.length - 1),
			values
		});
	}

	previous = () => {
		let { previousPage } = this.state;
		let page = previousPage.slice(-1)[0];
		// Remove the item we're about to use
		previousPage.pop();
		this.setState({
			...this.state,
			page: page,
			previousPage: previousPage
		});
	};

	handleSubmit = values => {
		const { children, onSubmit } = this.props;
		const { page } = this.state;
		const isLastPage = page === React.Children.count(children) - 1;
		if (isLastPage) {
			return onSubmit(values);
		}
		else {
			this.next(values);
		}
		// this.props.toTop.current.scrollIntoView({ behavior: "smooth" });
	}


	resetForm = (form) => {
		this.setState(this.baseState);
		this.props.questionReset();
		this.props.submit(false);
		return form.reset;
	}

	triggerFormDownload(form) {
		console.log('triggerFormDownload');
		this.props.setBypassValidation();
		const formElement = ReactDOM.findDOMNode(this);
		const checkbox = formElement.querySelector('input[type="checkbox"');
		const downloadButton = formElement.querySelector('#button-download');
		const signupButton = formElement.querySelector('#button-signup');
		//var checkboxError =  document.getElementById('#checkbox-error'); 
		var checkboxError = formElement.querySelector('#checkbox-error');
		var emailAddress = document.getElementById('#emailAddress');
		//var checkbox =  document.getElementById('#agreeToTerms'); 




		if (checkboxError) {
			checkboxError.style.display = "none";
		}
		/*if(checkbox){
		  checkbox.disabled = true;
		}*/


		if (emailAddress) {
			emailAddress.disabled = true;
		}
		//signupButton.disabled = true;

		setTimeout(function () {

			if (checkbox) {
				checkbox.click();
				checkbox.click();
				checkbox.disabled = true;
			}

			checkboxError = document.getElementById('#checkbox-error');
			if (checkboxError) {
				checkboxError.style.display = "none";
			}
			//

			emailAddress = document.getElementById('emailAddress');
			if (emailAddress) {
				emailAddress.disabled = true;
			}

			downloadButton.click();

			downloadButton.disabled = true;


		}, 10)
	}


	render() {
		const { children, noOfPages, submitted } = this.props;
		const { emailAddress, agreeToTerms } = this.props.questionOptions;
		const { page, values } = this.state;
		// Deduces which page we are currently using
		const activePage = React.Children.toArray(children)[page];
		// noOfPages passed from main form component
		const isFirstPage = page === 0;
		const isLastPage = page === noOfPages + 1;
		const url = '/support-and-resources#sign-up-stay-informed'

		// Build our lentils
		let pageLoop = 0;
		let lentils = [];

		while (pageLoop <= noOfPages + 1) {
			pageLoop++;
			lentils.push(<li key={pageLoop} className={(pageLoop <= (page + 1) ? "current" : "")}><span /></li>);
		}

		return (
			<Form
				initialValues={values}
				onSubmit={this.handleSubmit}
				decorators={[focusOnErrors]}
				mutators={{
					...arrayMutators
				}}
			>
				{({ form, handleSubmit, submitting, values }) => (
					<form onSubmit={handleSubmit}>
						<div className="row" style={{ position: "relative" }}>
							{page > 0 && !isLastPage && (
								<button className="btn text-center previous" type="button" onClick={() => this.previous()}>
									<svg width="50" height="50" viewBox="0 0 20 20" className="bi bi-chevron-left" style={{ fill: "#fff" }} xmlns="http://www.w3.org/2000/svg">
										<path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
									</svg>
								</button>
							)}
							<div className="discussion-guide">
								<div className="form-container">
									{submitted && (
										<div className="offer-signup">
											<div className="col-lg-6 offset-lg-3">
												<h2>Thank you!</h2>
												{!emailAddress && (<p>Please check your downloads folder for your completed discussion guide. <br></br> If you would like to receive important updates about <span style={{whiteSpace:'nowrap'}}>PD-related</span> hallucinations and delusions, click on the "Sign up now" button below.</p>)}
												{emailAddress && (<p>Please check your inbox for a copy of your completed discussion guide. <br></br> If you would like to receive important updates about <span style={{whiteSpace:'nowrap'}}>PD-related</span> hallucinations and delusions, click on the "Sign up now" button below.</p>)}

											</div>
											<div className="col-lg-12 pr-0 pl-0">
												<button type="button" onClick={() => { window.location.href = url; }}
													style={{ paddingTop: "6px" }}
													className="btn btn-primary btn-lg w-auto text-center">
													<b>Sign up now</b>
												</button>
												<button type="button" onClick={(form) => this.resetForm(form)}
													style={{ paddingTop: "6px", paddingBottom:'6px' }}
													className="btn btn-lg text-center text-center skip">
													<b>Start over</b>
												</button>
											</div>
										</div>
									)}
									{!submitted && (
										activePage
									)}
									{isLastPage && !submitted && (
										<div className="row mx-lg-4">
											<div className="col-sm-6">
												<button
													id="button-signup"
													className="btn btn-primary btn-lg w-100 text-center wide-mobile signup-btn"
													style={{ width: "90%", padding: "15px" }}
													type="submit"
													disabled={submitting || this.props.bypassValidation}
												>
													<b>Email my discussion&nbsp;guide</b>
												</button>
											</div>
											<div className="col-sm-6">
												<button
													id="button-download"
													className="btn btn-lg w-100 text-center text-center wide-mobile skip float-left"
													type="submit"
													style={{ width: "90%", padding: "15px" }}
													disabled={emailAddress || agreeToTerms || this.props.bypassValidation || submitting}
													onClick={(form) => this.triggerFormDownload(form)}
												>
													<b>Skip and print my discussion&nbsp;guide</b>
												</button>
											</div>
										</div>
									)}
								</div>
							</div>
							{/* {!isLastPage && !isFirstPage && (
								<button className="btn text-center next" type="submit" onClick={() => this.next}>
									<svg className="bi bi-chevron-right" width="50" height="50" viewBox="0 0 20 20" style={{ fill: "#fff" }} xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M6.646 3.646a.5.5 0 01.708 0l6 6a.5.5 0 010 .708l-6 6a.5.5 0 01-.708-.708L12.293 10 6.646 4.354a.5.5 0 010-.708z" /></svg>
								</button>
							)} */}
						</div>
						<ul className="dotstyle dotstyle-scaleup">
							{!submitted && page !== 7 && lentils}
						</ul>
						{process.env.NODE_ENV === "development" && (
							<pre style={{ marginTop: "100px", marginBottom: "50px" }}>{JSON.stringify(values, 0, 2)}</pre>
						)}
					</form>
				)}
			</Form>
		)
	}
}

const mapStateToProps = (state) => {
	const { questionOptions, submitted } = state;
	return { questionOptions: questionOptions, submitted: submitted };
}


export default connect(mapStateToProps, actions)(PageWizard);
